import { render, staticRenderFns } from "./Live2DWidget.vue?vue&type=template&id=1e0d2605&scoped=true"
import script from "./Live2DWidget.vue?vue&type=script&lang=js"
export * from "./Live2DWidget.vue?vue&type=script&lang=js"
import style0 from "./Live2DWidget.vue?vue&type=style&index=0&id=1e0d2605&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_bddh7bz47tm4asog4nvkp26dru/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e0d2605",
  null
  
)

export default component.exports